import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-markdown-editor', {
  mixins: [eventListenerMixin],

  connected() {
    this.source = this.querySelector('.editor-source');

    import('./editor').then(({ default: SimpleMDE }) => {
      this.editor = new SimpleMDE({
        element: this.source.querySelector('*:first-child') || this.source,
        toolbar: [
          'heading',
          'bold',
          'italic',
          'strikethrough',
          '|',
          'ordered-list',
          'unordered-list',
          'quote',
          'table',
          'horizontal-rule',
          'code',
          '|',
          'link',
          'image',
        ],
        forceSync: true,
        spellChecker: false,
        status: false,
        autoDownloadFontAwesome: true,
        autofocus: true,
      });
      this.classList.remove('loading');
      this.namespacedTrigger('editorReady', {
        detail: { editor: this.editor },
        bubbles: true,
      });
    });
  },
});
